import { shipmentStatuses } from '@reveni-io/reveni-ui'

import { parcelDirections, parcelStatusesByDirection } from '@/parcels/constants'

export const statusesByDirection = {
  [parcelDirections.outbound]: [...parcelStatusesByDirection[parcelDirections.outbound], shipmentStatuses.cancelled],
  [parcelDirections.inbound]: [...parcelStatusesByDirection[parcelDirections.inbound], shipmentStatuses.cancelled],
}
